var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-popover", [
    _c("div", { staticClass: "row gutter-xs q-pa-md" }, [
      _c(
        "div",
        { staticClass: "col-auto column" },
        [
          _c("q-btn", { attrs: { flat: "" }, on: { click: _vm.handleToday } }, [
            _vm._v(_vm._s(_vm.$t("today")))
          ]),
          _c(
            "q-btn",
            {
              staticClass: "q-mt-sm",
              attrs: { flat: "" },
              on: { click: _vm.handleWeek }
            },
            [_vm._v(_vm._s(_vm.$t("this_week")))]
          ),
          _c(
            "q-btn",
            {
              staticClass: "q-mt-sm",
              attrs: { flat: "" },
              on: { click: _vm.handleLastWeek }
            },
            [_vm._v(_vm._s(_vm.$t("last_week")))]
          ),
          _c(
            "q-btn",
            {
              staticClass: "q-mt-sm",
              attrs: { flat: "" },
              on: { click: _vm.handleMonth }
            },
            [_vm._v(_vm._s(_vm.$t("this_month")))]
          ),
          _c(
            "q-btn",
            {
              staticClass: "q-mt-sm",
              attrs: { flat: "" },
              on: { click: _vm.handleLastMonth }
            },
            [_vm._v(_vm._s(_vm.$t("last_month")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("date-picker", {
            ref: "datePicker",
            staticStyle: { border: "none" },
            attrs: {
              value: _vm.value,
              locale: _vm.locale,
              columns: 2,
              mode: "range",
              color: "indigo",
              "is-inline": ""
            },
            on: { input: _vm.handleInput }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }